import { getFlagValue } from '@databases/feature-flags/manager';
import { ObjectMode } from '@databases/types';
import { Database, DatabaseFieldType } from '@databases/types/database';
import { createField, getNewDatabase } from '@databases/utils/database/utils';

import { databasesToContentId } from './constants';

export const databaseWithBasicFields = (): Database<ObjectMode.EXISTING> => {
  const baseDatabase = getNewDatabase();

  const selectOptions = [
    {
      color: 'tealLight',
      id: '1',
      label: 'Small',
    },
    {
      color: 'yellowLight',
      id: '2',
      label: 'Medium',
    },
    {
      color: 'greenLight',
      id: '3',
      label: 'Large',
    },
    {
      color: 'tealLight',
      id: '4',
      label: 'Extra Small',
    },
    {
      color: 'greenLight',
      id: '5',
      label: 'Extra Large',
    },
    {
      color: 'redLight',
      id: '6',
      label: '"One-size-fits-all"',
    },
    {
      color: 'purpleLight',
      id: '7',
      label: 'No preference, any available',
    },
  ];
  const baseSelectField = createField(DatabaseFieldType.SELECT);
  const baseSelectFieldMulti = createField(DatabaseFieldType.SELECT);
  const isCheckboxEnabled = getFlagValue('databases-frontend-checkbox-field-type', false);

  const fields = [
    {
      ...createField(DatabaseFieldType.TEXT),
      name: `Text Field`,
    },
    {
      ...createField(DatabaseFieldType.ATTACHMENT),
      name: `Attachment Field`,
    },
    {
      ...createField(DatabaseFieldType.NUMBER),
      name: `Number Field`,
    },
    {
      ...createField(DatabaseFieldType.DATE),
      name: `Date Field`,
    },
    {
      ...baseSelectField,
      name: `Tag Field`,
      settings: {
        ...baseSelectField.settings,
        selectOptions: [
          ...selectOptions,
          {
            color: 'purpleLight',
            id: '8',
            label: 'Other',
          },
          {
            color: 'purpleLight',
            id: '9',
            label: 'None',
          },
        ],
      },
    },
    // TODO NCTD-2840 remove this once we refactor integration tests to allow
    // dynamic creation of databases
    {
      ...baseSelectFieldMulti,
      name: `Tag Field (multi)`,
      settings: {
        ...baseSelectField.settings,
        multi: true,
        selectOptions,
      },
    },
    {
      ...createField(DatabaseFieldType.USER),
      name: `User Field`,
    },
    {
      ...createField(DatabaseFieldType.HYPERLINK),
      name: `Link Field`,
    },
    ...(isCheckboxEnabled
      ? [{ ...createField(DatabaseFieldType.CHECKBOX), name: 'Checkbox Field' }]
      : []),
  ];

  return {
    ...baseDatabase,
    fields: fields.map((field) => field.id),
    fieldsById: Object.fromEntries(fields.map((field) => [field.id, field])),
    contentId: databasesToContentId['databaseWithBasicFields'],
    meta: {
      ...baseDatabase.meta,
      isLocked: false,
    },
    space: { key: 'TEST', name: 'Test', id: 1234 },
    operations: {
      delete: false,
      updateEntries: true,
      updateMetadata: true,
    },
  } as Database<ObjectMode.EXISTING>;
};
